export const generateHTMLHistogram = (
  d,
  tooltipData,
  colorScale,
  d3Format,
  ttMainFormat
) => {
  const myArray = [];

  // sort tooltipData in order of main value
  var sortedTooltipData = tooltipData.sort((a, b) => {
    return b[1] - a[1];
  });

  myArray.push(
    `<div class="tt-container"><div class="title">${d.metadata.longName}</div>`
  );

  sortedTooltipData.forEach((item) => {
    myArray.push(
      `<div class="row">
        <div class ="tt-color-container"><span style="height: 7px; width: 7px; border-radius: 30%; background-color: ${colorScale(
          item[0]
        )}; position: absolute; top: 30%"></span></div>
      <div class="tt-title">${item[0]}</div>
      <div class="tt-count">${item[2]}</div>
      <div class="tt-percent-container"><div class="tt-slash">&nbsp; /</div><div class="tt-percent">${d3Format(
        ttMainFormat
      )(item[1])}</div></div></div>`
    );
  });

  myArray.push('</div>');

  const joined = myArray.join('');
  return joined;
};
